import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography, Container, Grid } from '@mui/material';
import jwt_decode from 'jwt-decode';
import { storageHandler } from '../utils/storage_handler';

export default function HomePage() {
  const navigate = useNavigate();

  const goTo = (path) => () => navigate(path);

  // Determine which buttons to show based on token usertype
  let token = storageHandler.localStorageGet('token');
  let decoded = null;
  try {
    if (token) decoded = jwt_decode(token);
  } catch (e) { decoded = null; }

  const usertype = decoded && decoded.usertype ? decoded.usertype : null;

  // allowed routes for normal users (usertype == 2)
  const allowedForType2 = new Set([
    '/buxfer-management',
    '/buxfer-accounts',
    '/simplefin-accounts',
    '/buxfer-sync-history',
    '/gmail-messages',
    '/customers-credit-card'
  ]);


  const canSee = (path) => {
    if (!usertype) return false; // no token => nothing (PrivateRoute should redirect earlier)
    if (parseInt(usertype, 10) === 1) return true; // admin sees all
    if (parseInt(usertype, 10) === 2) return Array.from(allowedForType2).some(p => path.startsWith(p));
    return false;
  };

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#0f0f0f', color: 'white' }}>
      <Box sx={{ p: 2, borderBottom: '1px solid rgba(255,255,255,0.04)' }}>
        <Typography variant="h6">Card Manager App</Typography>
      </Box>

      <Container maxWidth="lg" sx={{ py: 8 }}>
        <Typography variant="h1" sx={{ fontSize: { xs: '48px', md: '96px' }, fontWeight: 700, textAlign: 'center', mb: 6 }}>Welcome to HomePage</Typography>

        <Grid container spacing={3} justifyContent="center">
          {canSee('/card-management') && (
          <Grid item>
            <Button onClick={goTo('/card-management')} sx={{ minWidth: 220, height: 56, bgcolor: '#90caf9', color: '#06283D', fontWeight: 700, borderRadius: 2 }}>
              GO TO CARD MANAGER
            </Button>
          </Grid>
          )}
          {canSee('/billing-statements') && (
          <Grid item>
            <Button onClick={goTo('/billing-statements')} sx={{ minWidth: 220, height: 56, bgcolor: '#90caf9', color: '#06283D', fontWeight: 700, borderRadius: 2 }}>
              GO TO BILLING STATEMENTS
            </Button>
          </Grid>
          )}
          {canSee('/amex-offers') && (
          <Grid item>
            <Button onClick={goTo('/amex-offers')} sx={{ minWidth: 220, height: 56, bgcolor: '#90caf9', color: '#06283D', fontWeight: 700, borderRadius: 2 }}>
              GO TO AMEX OFFERS
            </Button>
          </Grid>
          )}
          {canSee('/buxfer-management') && (
          <Grid item>
            <Button onClick={goTo('/buxfer-management')} sx={{ minWidth: 220, height: 56, bgcolor: '#90caf9', color: '#06283D', fontWeight: 700, borderRadius: 2 }}>
              GO TO BUXFER TRANSACTIONS
            </Button>
          </Grid>
          )}
          {canSee('/spending-report') && (
          <Grid item>
            <Button onClick={goTo('/spending-report')} sx={{ minWidth: 220, height: 56, bgcolor: '#90caf9', color: '#06283D', fontWeight: 700, borderRadius: 2 }}>
              GO TO SPENDING REPORT
            </Button>
          </Grid>
          )}
          {canSee('/buxfer-sync-history') && (
          <Grid item>
            <Button onClick={goTo('/buxfer-sync-history')} sx={{ minWidth: 220, height: 56, bgcolor: '#90caf9', color: '#06283D', fontWeight: 700, borderRadius: 2 }}>
              GO TO SYNC HISTORY
            </Button>
          </Grid>
          )}
          {canSee('/buxfer-accounts') && (
          <Grid item>
            <Button onClick={goTo('/buxfer-accounts/?page=1&rowsPerPage=50&orderBy=name&orderDirection=asc')} sx={{ minWidth: 220, height: 56, bgcolor: '#90caf9', color: '#06283D', fontWeight: 700, borderRadius: 2 }}>
              GO TO ACCOUNT PAGE
            </Button>
          </Grid>
          )}
          {canSee('/simplefin-accounts') && (
          <Grid item>
            <Button onClick={goTo('/simplefin-accounts/?page=1&rowsPerPage=50&orderBy=name&orderDirection=asc')} sx={{ minWidth: 220, height: 56, bgcolor: '#90caf9', color: '#06283D', fontWeight: 700, borderRadius: 2 }}>
              GO TO SIMPLEFIN ACCOUNTS
            </Button>
          </Grid>
          )}
          {canSee('/gmail-messages') && (
          <Grid item>
            <Button onClick={goTo('/gmail-messages')} sx={{ minWidth: 220, height: 56, bgcolor: '#90caf9', color: '#06283D', fontWeight: 700, borderRadius: 2 }}>
              GO TO GmailMessages PAGE
            </Button>
          </Grid>
          )}
          {canSee('/customers-credit-card') && (
            <Grid item>
              <Button onClick={goTo('/customers-credit-card')} sx={{ minWidth: 220, height: 56, bgcolor: '#90caf9', color: '#06283D', fontWeight: 700, borderRadius: 2 }}>
                GO TO CUSTOMER CREDIT CARDS
              </Button>
            </Grid>
          )}
        </Grid>
      </Container>
    </Box>
  );
}